<template>
<div v-if="isShow">
    <header>安心してご利用いただくために<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="txt-area">
            <p>あああああああああああああああああああああああああああああああああああああああああああああ</p>
        </div>
    </div>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean
    },
    emits: ['close'],
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
}
</script>
